import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VendorUser } from '../helpers/InterfacesServer';

interface VendorUsersState {
  value: VendorUser[]
}

export const vendorUsers = createSlice({
  name: 'vendorUsers',
  initialState: {
    value: [],
  } as VendorUsersState,
  reducers: {
    setVendorUsers: (state, action: PayloadAction<VendorUser[]>) => {
      state.value = action.payload
    },
  },
})

export const { setVendorUsers } = vendorUsers.actions;
export default vendorUsers.reducer;